import {
  TriangleAlert as WarningRegular,
  Mail as MailRegular,
  ExternalLink as OpenRegular,
} from "lucide-react";
import React, { useEffect } from "react";
import {
  SkyBody1,
  SkyButton,
  SkyCap1,
  SkyLink,
  SkyTitle1,
  SkyTitle3,
} from "@skypointcloud/skypoint-ui";

const InactivePlan = (): React.ReactElement => {
  useEffect(() => {
    document.body.classList.add("body-gray");
    return () => {
      document.body.classList.remove("body-gray");
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-surface-subtle">
      <div className="flex justify-center items-center flex-1 p-8">
        <div className="max-w-[560px] w-full text-center bg-white rounded-2xl p-12 shadow-lg">
          <div className="mb-8">
            <img
              src="dist/img/skyPoint-logo-text-black.svg"
              alt="Skypoint"
              className="h-[48px]"
            />
          </div>

          <div className="flex justify-center mb-6">
            <WarningRegular className="text-yellow-500" />
          </div>

          <SkyTitle1
            as="h1"
            className="mb-4 text-fg-1"
          >
            Account Deactivated
          </SkyTitle1>

          <SkyBody1 className="mb-8 text-fg-2 leading-[1.6] block">
            Your company's Skypoint account has been deactivated. You can easily reactivate your
            service by subscribing to a Skypoint Plan as a tenant administrator.
          </SkyBody1>

          <div className="flex flex-col gap-4 mb-8">
            <a
              href="https://skyadvisor.skypoint.ai/"
              target="_blank"
              rel="noreferrer"
              className="no-underline"
            >
              <SkyButton
                appearance="primary"
                size="large"
                icon={OpenRegular}
                className="min-w-[200px]"
              >
                Reactivate Account
              </SkyButton>
            </a>
          </div>

          <div className="my-6 h-[1px] bg-sidebar-active" />

          <div className="flex flex-col items-center gap-3">
            <SkyTitle3 className="text-fg-3 text-sm">Need help?</SkyTitle3>
            <SkyLink
              href="mailto:support@skypoint.ai"
              className="flex items-center gap-2"
            >
              <MailRegular className="text-xl" />
              support@skypoint.ai
            </SkyLink>
          </div>
        </div>
      </div>
      <footer className="p-4 text-center border-t border-gray-300 bg-surface">
        <SkyCap1 className="text-fg-3">
          Copyright &copy; {new Date().getFullYear()}{" "}
          <SkyLink
            href="https://skypoint.ai"
            target="_blank"
          >
            Skypoint Cloud, Inc.
          </SkyLink>
          . All rights reserved.
        </SkyCap1>
      </footer>
    </div>
  );
};

export default InactivePlan;
